import React from 'react';
import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import Tree from '../common/tree/Tree';
import TreeNodes from '../common/tree/TreeNodes';

const withDemographic = TreeNodesComponent => props => {
  const DEMOGRAPHIC_QUERY = !props.id
    ? gql`
        query getTopLevelDemographicQuery {
          topLevelDemographics {
            id
            name
            childCount
            metricCount
          }
        }
      `
    : gql`
        query getDemographicChildrenQuery($id: String) {
          demographicChildren(id: $id) {
            id
            name
            childCount
            metricCount
          }
        }
      `;
  const { loading, error, data } = useQuery(DEMOGRAPHIC_QUERY, { variables: { id: props.id } });

  return (
    <TreeNodesComponent
      {...props}
      queryResult={{
        loading,
        error,
        data: data && (data.topLevelDemographics || data.demographicChildren)
      }}
    />
  );
};

const DemographicTree = props => {
  const DemographicTreeNodes = withDemographic(TreeNodes);
  return <Tree {...props} childComponent={DemographicTreeNodes} />;
};

export default DemographicTree;
